import {fetchTable} from '../api/volleynet';
import {fetchArticles, fetchCategories, fetchPost} from '../api/wordpress';
import {useCachedResource} from './useCachedResource';

export const useArticles = () => useCachedResource('articles', fetchArticles);

export const useCategories = () => useCachedResource('categories', fetchCategories);

export const usePost = (id: string | number) => useCachedResource(`post:${id}`, () => fetchPost(id));

export const useLeagueTable = (bewId: string) => useCachedResource(`table:${bewId}`, () => fetchTable(bewId));
